const HEX_COLOR_PATTERN = /#(?:[0-9A-Fa-f]{8}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{3})\b/g;
const SEPARATOR_ONLY_PATTERN = /^[,\s/&|+-]*$/;

export type FontColorValueMetadata = {
  detectedHexColors: string[];
  singlePreviewHex: string | null;
};

export function getFontColorValueMetadata(value: string | undefined): FontColorValueMetadata {
  if (!value) {
    return { detectedHexColors: [], singlePreviewHex: null };
  }

  const detectedHexColors = value.match(HEX_COLOR_PATTERN) ?? [];
  if (detectedHexColors.length !== 1) {
    return { detectedHexColors, singlePreviewHex: null };
  }

  const singleHex = detectedHexColors[0];
  const remainingContent = value.replace(singleHex, "").trim();
  const hasOnlySeparators =
    remainingContent.length === 0 || SEPARATOR_ONLY_PATTERN.test(remainingContent);

  return {
    detectedHexColors,
    singlePreviewHex: hasOnlySeparators ? singleHex : null
  };
}
